@if (viewModel$ | async; as viewModel) {
    <div class="result-summary">
        @if (viewModel.numberOfFailedBets > 0) {
            <bs-alert [type]="failedBetsAlertType" [message]="getDeclinedBetsMessage(viewModel.numberOfFailedBets)" />
        }
        <div class="result-summary__rows">
            <div class="result-summary-row result-summary-row--grid">
                <span>{{ messages.numberOfBetsPlaced }}</span>
                <span class="result-summary-row__value">{{ viewModel.numberOfBetsPlaced }}</span>
            </div>
            <div class="result-summary-row result-summary-row--grid">
                <span>{{ messages.totalStake }}</span>
                <span class="result-summary-row__value">{{ viewModel.totalStake | bsCurrency: true }}</span>
            </div>
            <div class="result-summary-row result-summary-row--grid">
                @if (showGrossReturns(viewModel.totalReturnsGross, viewModel.totalReturnsNet)) {
                    <span>{{ messages.totalReturns }}</span>
                } @else {
                    <div class="result-summary__net-returns">
                        <span>{{ messages.totalReturnsNet }}</span
                        ><span class="theme-info result-summary__taxation-info" (click)="displayTaxationInfo()"></span>
                    </div>
                }
                <span class="result-summary-row__value">{{ getTotalReturnsValue(viewModel) | bsCurrency: true }}</span>
            </div>
        </div>
        <div class="result-summary__actions">
            @if (inColumn) {
                <button class="btn btn-primary" [msAutomation]="'betslip-back-button'" (click)="closeResult()">
                    {{ messages.closeResult }}
                </button>
            } @else {
                <button class="btn btn-light" [ngClass]="{ 'btn-md': !isEpcot, 'btn-lg': isEpcot }" (click)="goToMyBets()">
                    {{ messages.goToMyBets }}
                </button>
                <button
                    class="btn btn-primary"
                    [ngClass]="{ 'btn-md': !isEpcot, 'btn-lg': isEpcot }"
                    [msAutomation]="'betslip-back-button'"
                    (click)="viewModel.hasRemainingBetsInBetslip ? goToBetslip() : closeResult()">
                    {{ viewModel.hasRemainingBetsInBetslip ? messages.viewBetslip : messages.closeResultDone }}
                </button>
            }
        </div>
    </div>
    @if (isTaxationInfoVisible) {
        <bs-digital-taxation-info
            [vm]="getTaxationVm(viewModel.totalReturnsGross, viewModel.totalReturnsNet)"
            [(isVisible)]="isTaxationInfoVisible" />
    }
}
